<template>
  <div>
    <p>
      Change your 4-digit pin code to be used for transactions on your EvedPay Card.<br />
      Pin requirements:<br />
      <ul style="padding-inline-start:20px">
        <li>not be all the same digit, ex. 1111</li>
        <li>not be digits in sequence, ex. 1234</li>
        <li>not match the last four digits of the card number.</li>
      </ul>
    </p>
    <div class="table-responsive">
      <table class="table">
        <tr>
          <th>Card Number</th>
          <th>Card Holder</th>
        </tr>
        <tr>
          <td>{{ card.CardNumber }}</td>
          <td>{{ card.Holder.Name }}</td>
        </tr>
      </table>
      <div>
        <p><strong>New 4-Digit Pin</strong></p>
        <input :type="showNewPin ? 'text' : 'password'" v-model="newPin" maxlength="4" @input="allowOnlyNumbers('newPin', $event)"/>
        <i :class="`toggle-pin-icon ${showNewPin ? 'fas fa-eye-slash' : 'fas fa-eye'}`" @click="toggleNewPinVisibility"></i>
        <br />
        <br />
        <p><strong>Confirm New 4-Digit Pin</strong></p>
        <input :type="showConfirmPin ? 'text' : 'password'" v-model="confirmPin" maxlength="4" @input="allowOnlyNumbers('confirmPin', $event)" />
        <i :class="`toggle-pin-icon ${showConfirmPin ? 'fas fa-eye-slash' : 'fas fa-eye'}`" @click="toggleConfirmPinVisibility"></i>
        <p v-if="pinError" class="pin-error">{{ pinError }}</p>
        <br />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newPin: '',
      pinError: '',
      confirmPin: '',
      showNewPin: false,
      showConfirmPin: false
    }
  },
  props: {
    card: Object
  },
  methods: {
    validatePin(pin, confirmPin) {
      if (!pin) {
        return 'PIN cannot be empty.'
      }

      if (pin.length !== 4) {
        return 'PIN must be exactly 4 digits.'
      }

      if (!/^\d+$/.test(pin)) {
        return 'PIN must contain only numbers.'
      }

      if (/^(\d)\1+$/.test(pin)) {
        return 'PIN cannot be all the same digit.'
      }

      const numbers = '01234567890'
      const reverseNumbers = '09876543210'
      if (numbers.includes(pin) || reverseNumbers.includes(pin)) {
        return 'PIN cannot contain digits in sequence.'
      }

      if (pin !== confirmPin) {
        this.newPin = ''
        this.confirmPin = ''
        return 'PIN does not match'
      }

      if (this.card.CardNumber === pin) {
        this.newPin = ''
        this.confirmPin = ''
        return 'PIN cannot be similar to the last 4 digits of the card!'
      }

      return ''
    },

    allowOnlyNumbers(field, event) {
      const value = event.target.value
      if (!/^\d*$/.test(value)) {
        if (field === 'newPin') {
          this.newPin = value.replace(/[^0-9]/g, '')
        } else if (field === 'confirmPin') {
          this.confirmPin = value.replace(/[^0-9]/g, '')
        }
      }
    },

    toggleNewPinVisibility() {
      this.showNewPin = !this.showNewPin
    },
    toggleConfirmPinVisibility() {
      this.showConfirmPin = !this.showConfirmPin
    },
    async changePIN(pin = this.newPin, confirmPin = this.confirmPin, showModal) {
      this.pinError = ''
      const validationError = this.validatePin(pin, confirmPin)
      if (validationError) {
        this.pinError = validationError
        return
      }

      try {
        if (this.card.Id && pin && confirmPin) {
          const response = await this.api.patch(`evedpaycards/${this.card.Id}/set-pin`, {
            pin: pin
          })

          if (response.status === 200) {
            showModal.showModal = false
            this.$emit('pinChangeSuccess')
          } else {
            this.pinError = 'Failed to change pin'
          }
        }
      } catch (error) {
        this.pinError = 'Failed to change pin'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.card-status-overlay {
  background-color: white;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}
.pin-error {
  color: red;
}

.toggle-pin-icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-list/CardPIN.vue